export enum OrgUnitSelectionStatus {
  OK = 0,
  LESS_THAN_MIN_RESPONDENT_AMOUNT = 1,
  NEGATIVE_SELECTION = 2,
  UNDEFINED = 3,
}
